/*
 * Bottom-nav icon set. Inline SVG on a shared 24px grid so every glyph
 * carries the same stroke weight and optical size, and so the active state
 * can switch stroke/fill without swapping assets.
 */

const base = {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.7,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": "true",
};

export const HomeIcon = () => (
  <svg {...base}>
    <path d="M3 10.2 12 3l9 7.2" />
    <path d="M5.5 9.2V20h13V9.2" />
    <path d="M9.8 20v-5.2h4.4V20" />
  </svg>
);

export const CategoryIcon = () => (
  <svg {...base}>
    <rect x="3.2" y="3.2" width="7.2" height="7.2" rx="1.8" />
    <rect x="13.6" y="3.2" width="7.2" height="7.2" rx="1.8" />
    <rect x="3.2" y="13.6" width="7.2" height="7.2" rx="1.8" />
    <rect x="13.6" y="13.6" width="7.2" height="7.2" rx="1.8" />
  </svg>
);

/* Centre action — a shopfront, drawn a touch heavier to hold the pill. */
export const ShopIcon = () => (
  <svg {...base} strokeWidth="1.8">
    <path d="M4 9.5V19a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9.5" />
    <path d="M3 5.5h18l1 4a2.6 2.6 0 0 1-5.1.6 2.6 2.6 0 0 1-4.9.6 2.6 2.6 0 0 1-4.9-.6A2.6 2.6 0 0 1 2 9.5z" />
    <path d="M9.6 20v-5h4.8v5" />
  </svg>
);

export const CartIcon = () => (
  <svg {...base}>
    <circle cx="9.5" cy="20" r="1.4" />
    <circle cx="18" cy="20" r="1.4" />
    <path d="M2.5 3.5h2.6l2.2 11.1a1.6 1.6 0 0 0 1.6 1.3h8.4a1.6 1.6 0 0 0 1.6-1.3l1.4-7.2H6" />
  </svg>
);

export const ProfileIcon = () => (
  <svg {...base}>
    <circle cx="12" cy="8" r="3.8" />
    <path d="M4.6 20.2a7.6 7.6 0 0 1 14.8 0" />
  </svg>
);

export const CloseIcon = () => (
  <svg {...base} strokeWidth="2">
    <path d="M6 6l12 12M18 6L6 18" />
  </svg>
);
